import React from "react";
import './Popup.css'
import './Profile.jsx'

export default class Popup extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        popupStatus: props
      }
      console.log("This is the popup function")
    console.log(sessionStorage.getItem("user"))
    }


    
    render(){
     return (this.props.trigger) ? (
         <div className="popups">
            <div className="popup-inner">
                <p className="headingText" >Are you sure you want to delete your account?</p>
            <button className="approve" onClick={this.props.deletehandler}><form className="yesText">Yes</form></button>
            <button className="cancel" onClick={this.props.handlerFunction}><form className="noText">No</form></button>
            </div>
         </div>
     ) :''
 }
}

